import { deliveryTypes } from '../types/delivery-types';

const initialDatesTimes = {
  deliveryDate: '',
  deliveryTime: '',
  pickupDate: '',
  pickupTime: '',
};

export const deliveryReducer = (state, action) => {
  const { type, payload } = action;
  const {
    SET_DELIVERY_ADDRESS,
    SET_DELIVERY_DATES_TIMES,
    RESET_DATES_TIMES,
    SET_ACTIVE_SECTION,
    SET_ITEM_DETAILS,
    SET_ENABLE_DATES_TIMES_FORM
  } = deliveryTypes;

  switch (type) {
  case 'SET_DAMAGE_OPT_IN_STATUS':
    return {
      ...state,
      damageProtection: payload
    };
  case SET_DELIVERY_ADDRESS:
    return {
      ...state,
      deliveryAddress: {
        ...state.deliveryAddress,
        [payload.field]: payload.value
      }
    };
  case SET_ITEM_DETAILS:
    return {
      ...state,
      canonicalUrl: payload.canonicalUrl,
      rentalCategory: payload.rentalCategory,
      rentalSubCategory: payload.rentalSubCategory
    };
  case SET_ENABLE_DATES_TIMES_FORM:
    return {
      ...state,
      deliveryDatesTimes: {
        ...state.deliveryDatesTimes,
        isFormEnabled: payload.isFormEnabled
      }
    };
  case SET_DELIVERY_DATES_TIMES:
    return {
      ...state,
      deliveryDatesTimes: {
        ...state.deliveryDatesTimes,
        [payload.field]: payload.value
      }
    };
  case RESET_DATES_TIMES:
    return {
      ...state,
      deliveryDatesTimes: initialDatesTimes,
    };
  case SET_ACTIVE_SECTION:
    return {
      ...state,
      activeSection: payload
    };
  case 'SET_RENTAL_CONTRACT_TERMS':
    return {
      ...state,
      contractTerms: payload
    };
  case 'SET_STATEMENTS_OF_UNDERSTANDING':
    return {
      ...state,
      statementsOfUnderstanding: payload
    };
  default:
    return state;
  }
};
